webpackJsonp([128416023490207],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 0 0 ', ' 0;\n'], ['\n  padding: 0 0 ', ' 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _H = __webpack_require__(30);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _authors = __webpack_require__(172);
	
	var _structuredData = __webpack_require__(174);
	
	var _BigFirstLetter = __webpack_require__(96);
	
	var _BigFirstLetter2 = _interopRequireDefault(_BigFirstLetter);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactIntl = __webpack_require__(7);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Header = _styledComponents2.default.header(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(2);
	});
	
	var AboutPage = function AboutPage(props) {
	  var author = (0, _authors.getAuthor)('angeloocana');
	
	  author.description = props.i18n.descriptionForGoogle;
	  var menu = props.data.site.siteMetadata.resume.menu;
	
	
	  var structuredData = (0, _structuredData.getStructuredDataForAuthor)(author);
	
	  return _react2.default.createElement(
	    _ResumeContainer2.default,
	    { menu: menu, selectedPage: '/about/' },
	    _react2.default.createElement(
	      _BigFirstLetter2.default,
	      null,
	      _react2.default.createElement('script', {
	        type: 'application/ld+json',
	        dangerouslySetInnerHTML: { __html: structuredData }
	      }),
	      _react2.default.createElement(
	        _reactIntl.FormattedMessage,
	        { id: 'about' },
	        function (txt) {
	          return _react2.default.createElement(
	            Header,
	            null,
	            _react2.default.createElement(_reactHelmet2.default, {
	              title: txt,
	              meta: [{ name: 'description', content: txt }]
	            }),
	            _react2.default.createElement(
	              _H2.default,
	              null,
	              txt
	            )
	          );
	        }
	      ),
	      props.i18n.description
	    )
	  );
	};
	
	AboutPage.propTypes = {
	  i18n: _propTypes2.default.shape({
	    description: _propTypes2.default.object.isRequired,
	    descriptionForGoogle: _propTypes2.default.string.isRequired
	  }).isRequired,
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AboutPage = __webpack_require__(116);
	
	var _AboutPage2 = _interopRequireDefault(_AboutPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var i18n = {
	  description: _react2.default.createElement(
	    'p',
	    null,
	    'Hi! I am \xC2ngelo, a Freelance Full-Stack Developer since 2007. My professional journey started when I was 14 years-old. Since then, I have been passionate about programming.  ',
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    'Most recently, I have my mindset on TDD, Functional Programming, Offline First, Mobile First and Frog Cloud. ',
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    'I\u2019m an Arch Linux user and Nodejs Developer.'
	  ),
	  descriptionForGoogle: '\n    My professional journey started when I was 14 years-old. Since then, I have been passionate about programming. Most recently, I have my mindset on TDD, Functional Programming, Offline First, Mobile First \n    and Frog Cloud.\n    \n    I\u2019m an Arch Linux user.\n  '
	};
	
	exports.default = function (props) {
	  return _react2.default.createElement(_AboutPage2.default, _extends({ i18n: i18n }, props));
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-en-js-2a58ec2ffe2b77037cf3.js